import HttpRequest from './http_request'

export default class AuthProvider extends HttpRequest {
  login (username, password) {
    return this.post('auth/login', { username, password })
  }
}
